/* =====================================================================
   EVERSFIELD CHRISTMAS 2026 — behaviour for the xmas-* sections
   No libraries. Safe to load more than once (sections each include it).
   1. Scrollers: arrows + edge fades for chips, rails and the carousel
   2. Pinned collection navigation, shown once the in-page row is passed
   3. Scroll-spy: highlights the rail you are in; holds still on chip clicks
   4. Carousel progress bar
   Re-runs when a section is edited in the theme editor.
   ===================================================================== */
(function () {
  'use strict';

  /* Height of Focal's sticky header (and sticky announcement bar, if enabled) — the
     same sum theme.js uses. Reads the theme's own variables, so it follows the setting. */
  function stickyOffset() {
    var cs = getComputedStyle(document.documentElement);
    var n = function (v) { return parseInt(cs.getPropertyValue(v), 10) || 0; };
    return n('--header-height') * n('--enable-sticky-header') + n('--announcement-bar-height') * n('--enable-sticky-announcement-bar');
  }

  function wireScroller(track) {
    if (track.dataset.xmasWired) return;
    track.dataset.xmasWired = '1';
    var box = track.parentElement;
    var prev = box.querySelector('.xmas-scroller__nav--prev');
    var next = box.querySelector('.xmas-scroller__nav--next');
    var bar = box.parentElement && box.parentElement.querySelector('[data-xmas-progress]');

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft < 8, atEnd = track.scrollLeft > max - 8 || max < 8;
      if (prev) prev.hidden = atStart;
      if (next) next.hidden = atEnd;
      box.classList.toggle('at-start', atStart);
      box.classList.toggle('at-end', atEnd);
      if (bar) {
        var vis = max > 0 ? track.clientWidth / track.scrollWidth : 1;
        bar.style.width = (vis * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / vis) - 1) * 100 : 0) + '%)';
      }
    }
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function wireNav(root) {
    var sentinel = root.querySelector('.xmas-nav__sentinel');
    var sticky = root.querySelector('[data-xmas-stickynav]');
    var rows = [].slice.call(root.querySelectorAll('[data-xmas-chips]'));
    var rails = [].slice.call(root.querySelectorAll('.xmas-rail[id]'));
    if (!rows.length || !rails.length || root.dataset.xmasNav) return;
    root.dataset.xmasNav = '1';

    /* 2 — pinned nav: shown once the in-page row has gone under Focal's sticky
       header (not the top of the screen), so there's never a gap with neither visible */
    function pin() {
      if (!sticky || !sentinel) return;
      var past = sentinel.getBoundingClientRect().top < stickyOffset();
      sticky.classList.toggle('is-on', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
    }

    /* 3 — scroll-spy */
    var current = null, lock = false, ticking = false, releaseT = null;
    function centre(row, el) {
      var max = row.scrollWidth - row.clientWidth;
      if (max <= 0) return;
      var left = el.offsetLeft - (row.clientWidth - el.offsetWidth) / 2;
      row.scrollTo({ left: Math.max(0, Math.min(left, max)), behavior: 'smooth' });  /* horizontal only — never moves the page */
    }
    function setCurrent(id) {
      if (id === current) return;
      current = id;
      rows.forEach(function (row) {
        row.querySelectorAll('.xmas-chip').forEach(function (c) {
          var on = c.getAttribute('href') === '#' + id;
          c.classList.toggle('is-current', on);
          if (on) { c.setAttribute('aria-current', 'true'); centre(row, c); } else c.removeAttribute('aria-current');
        });
      });
    }
    function spy() {
      ticking = false;
      pin();
      if (lock) return;
      var line = Math.max(stickyOffset() + 60, window.innerHeight * 0.35), id = null;
      for (var i = 0; i < rails.length; i++) {
        if (rails[i].getBoundingClientRect().top <= line) id = rails[i].id; else break;
      }
      setCurrent(id);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
    window.addEventListener('resize', spy);
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href*="#"]');
      if (!a) return;
      var url;
      try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
      if (url.pathname !== location.pathname || !url.hash) return;          /* only links to this page */
      var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target || rails.indexOf(target) === -1) return;                  /* only jumps to a rail */
      ev.preventDefault();
      setCurrent(target.id); lock = true; clearTimeout(releaseT);
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      var release = function () { clearTimeout(releaseT); lock = false; spy(); };
      if ('onscrollend' in window) window.addEventListener('scrollend', release, { once: true });
      releaseT = setTimeout(release, 1400);
    });
    spy();
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-xmas-scroller]').forEach(wireScroller);
    scope.querySelectorAll('.shopify-section--xmas-rails').forEach(wireNav);
  }

  if (!window.__xmasInit) {
    window.__xmasInit = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
})();
